import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { KPIRow } from '../components/KPIRow';
import { DialingListGrid, DialingList } from '../components/DialingListGrid';
import { CriteriaPanel } from '../components/CriteriaPanel';
import { AnalyticsSection } from '../components/AnalyticsSection';
import { SyncValidation } from '../components/SyncValidation';
import { ScenarioBuilder } from '../components/ScenarioBuilder';
import { ActivityFeed } from '../components/ActivityFeed';
export function Dashboard() {
  const [selectedList, setSelectedList] = useState<DialingList | null>(null);
  const isOpen = selectedList !== null;
  return <Layout data-id="element-370">
      <div className="p-6 max-w-[1600px] mx-auto" data-id="element-371">
        {/* Top KPI Summary Row */}
        <KPIRow data-id="element-372" />

        {/* Primary Dialing List Grid */}
        <DialingListGrid onSelectList={setSelectedList} selectedListId={selectedList?.id} data-id="element-373" />

        {/* Historical Analytics */}
        <AnalyticsSection data-id="element-374" />

        {/* Bottom Grid: Sync, Scenario, Feed */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-12 gap-6 mb-8" data-id="element-375">
          <div className="lg:col-span-2 xl:col-span-6" data-id="element-376">
            <SyncValidation data-id="element-377" />
          </div>
          <div className="xl:col-span-3" data-id="element-378">
            <ScenarioBuilder data-id="element-379" />
          </div>
          <div className="xl:col-span-3" data-id="element-380">
            <ActivityFeed data-id="element-381" />
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div onClick={() => setSelectedList(null)} aria-hidden={!isOpen} className={`fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} data-id="element-382" />

      {/* Slide-over Panel */}
      <div className={`fixed inset-y-0 right-0 z-50 transform transition-transform duration-300 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} aria-hidden={!isOpen} data-id="element-383">
        <CriteriaPanel list={selectedList} onClose={() => setSelectedList(null)} data-id="element-384" />
      </div>
    </Layout>;
}